export default __webpack_public_path__ + "static/media/Copy Icon.d1421e0b.svg";